<button
  #nativeButton
  [id]="id"
  [ngClass]="getClassObject()"
  [ngStyle]="{ width: fullWidth ? '100%' : 'auto' }"
  [disabled]="disabled"
  [type]="submit ? 'submit' : 'button'"
  [attr.form]="formId"
  [attr.aria-label]="ariaLabel"
  (click)="handleClick($event)"
  (keydown)="handleKeyDown($event)"
>
  <div class="button-container" [ngStyle]="{ 'flex-direction': getTextAlign() }">
    @if(iconSvg){
    <img class="icon-svg" [src]="iconSvg" alt="Icon" />
    } @if(iconName){
    <span class="material-symbols-outlined">{{ iconName }}</span>
    } @if(label){
    {{ label }}
    }
  </div>
</button>
